
import React from 'react';

interface WizardHeaderProps {
  stepLabel: string;
  currentStep: number;
  totalSteps: number;
}

export const WizardHeader = ({ stepLabel, currentStep, totalSteps }: WizardHeaderProps) => {
  return (
    <div className="border-b bg-muted/40 px-6 py-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">{stepLabel}</h2>
        <span className="text-sm text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
      </div>
    </div>
  );
};
